import { getLocalTimeZone, today } from '@internationalized/date';
import { enumWeightDisplayUnit } from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { createBrokeredLoadAtom } from '../_graphql/mutationBrokeredLoadCreate';
import { brokeredLoadGetNextDocumentNumberAtom } from '../_graphql/mutationBrokeredLoadGetNextDocumentNumber';
import { brokeredOrderLinkedOrdersQueryAtom } from '../_graphql/queryBrokeredOrderLinkedOrders';
import { brokeredLoadSalesOrderLineItemsQueryAtom } from '../_graphql/querySalesOrderLineItems';
import { BrokeredLoadFormState } from '../types/brokeredLoad';

export const initialBrokeredLoadFormState = (): BrokeredLoadFormState => ({
  documentNumber: undefined,
  supplierId: undefined,
  brokeredOrderId: undefined,
  salesOrderId: undefined,
  bookingId: undefined,
  facilityId: undefined,
  expectedShipDate: today(getLocalTimeZone()),
  status: undefined,
  weightDisplayUnit: enumWeightDisplayUnit.PriceUnit,
  deliveryNumber: undefined,
  lineItems: [],
});

// 🔘🔘🔘 FORM STATE
export const $brokeredLoadCreateForm = atom<BrokeredLoadFormState>(
  initialBrokeredLoadFormState(),
);

// 🔘🔘🔘 DIALOG STATE
export const $isCreateDialogOpen = atom<boolean>(false);

// 🔘🔘🔘 COMPUTED -> is form valid
export const $isFormValid = atom((get) => {
  const form = get($brokeredLoadCreateForm);
  return !!(form.supplierId && form.expectedShipDate && form.facilityId);
});

// 🔘🔘🔘 ACTION -> reset form
export const $resetForm = atom(null, (_, set) => {
  set($brokeredLoadCreateForm, initialBrokeredLoadFormState());
});

// 🔘🔘🔘 MUTATION -> create brokered load
export const $createBrokeredLoad = createBrokeredLoadAtom({});

// 🔘🔘🔘 MUTATION -> get next document number
export const $nextLoadDocumentNumber = brokeredLoadGetNextDocumentNumberAtom(
  {},
);

// 🟢🟢🟢 REMOTE DATA -> sales order line items for create form
export const $createFormSalesOrderLineItems =
  brokeredLoadSalesOrderLineItemsQueryAtom((get) => ({
    variables: {
      salesOrderId: get($brokeredLoadCreateForm).salesOrderId ?? '',
    },
    skip: !get($brokeredLoadCreateForm).salesOrderId,
  }));

// 🟢🟢🟢 REMOTE DATA -> brokered order linked orders
export const $brokeredOrderLinkedOrders = brokeredOrderLinkedOrdersQueryAtom(
  (get) => {
    const form = get($brokeredLoadCreateForm);
    return {
      variables: { id: form.brokeredOrderId ?? '' },
      skip: !form.brokeredOrderId,
    };
  },
);
